import { computed } from 'vue'
import builderIoService from '~/composables/builderIoService'
import { useLocaleStore } from '~/stores/localeStore';
import { CONTENT_TYPES } from '~~/shared/utils/contentTypes'
import { useAsyncData } from 'nuxt/app';

export const useTrending = async () => {
  const service = builderIoService()
  const localeStore = useLocaleStore()
  const limit = 3

  const countryCode = computed(() => {
    const code = (localeStore.locale as any)?.country?.code
    return typeof code === 'string' && code.trim() ? code.trim() : 'US'
  })

  const sort = {
    'data.publishAt': -1 as const
  }

  const query = computed(() => ({
    $and: [
      {
        'data.taggings': {
          $elemMatch: { tag: 'Trending' }
        }
      },
      {
        $or: [
          { 'data.countryRestrictionsWhitelist': { $exists: false } },
          { 'data.countryRestrictionsWhitelist': { $size: 0 } },
          {
            'data.countryRestrictionsWhitelist.countryCode': {
              $in: [countryCode.value]
            }
          }
        ]
      },
      {
        'data.countryRestrictionsBlacklist.countryCode': {
          $nin: [countryCode.value]
        }
      }
    ],
    'data.status': 'Active'
  }))

  const { data, error } = await useAsyncData(
    () => `trending-${countryCode.value}`,
    async () => {
      const response = await service.fetchManyModels(
        CONTENT_TYPES.TAKE_FIVE_DAILY,
        '/',
        false,
        {
          limit,
          query: query.value,
          sort: sort,
          fields: [
            'data.entityType',
            'data.name',
            'data.urlKey',
            'data.taggings.tag',
            'data.publishAt'
          ]
        }
      )

    return response
  }, {
    server: true,
    lazy: false,
    default: () => [],
    watch: [countryCode]
  })

  return { data, error }
}
